/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
 */

import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { lazy, Suspense } from 'react';
import { useTheme } from './context/ThemeContext';
import Header from './components/Header';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import InteractiveBackground from './components/InteractiveBackground';
import WhatsAppFAB from './components/WhatsAppFAB';
import { AuthGuard } from './components/AuthGuard';

import Home from './pages/Home';
const Intelligence = lazy(() => import('./pages/Intelligence'));
const Compliance = lazy(() => import('./pages/Compliance'));
const Markets = lazy(() => import('./pages/Markets'));
const ArticleDetail = lazy(() => import('./pages/ArticleDetail'));
const GoldenTicket = lazy(() => import('./pages/GoldenTicket'));
const Events = lazy(() => import('./pages/Events'));
const Auth = lazy(() => import('./pages/Auth'));
const AdminBlog = lazy(() => import('./pages/AdminBlog'));
const Profile = lazy(() => import('./pages/Profile'));
const NuestraEmpresa = lazy(() => import('./pages/NuestraEmpresa'));
const DiagnosticoExpress = lazy(() => import('./pages/DiagnosticoExpress'));
const Methodology = lazy(() => import('./pages/Methodology'));
const AdminDashboard = lazy(() => import('./pages/AdminDashboard'));
const LegalPage = lazy(() => import('./pages/LegalPage'));
const ConsultationBooking = lazy(() => import('./pages/ConsultationBooking'));
const ResetPassword = lazy(() => import('./pages/ResetPassword'));
const SetPassword = lazy(() => import('./pages/SetPassword'));

export default function App() {
  const { theme } = useTheme();
  const isDark = theme === 'dark';
  return (
    <Router>
      <ScrollToTop />
      <InteractiveBackground />
      <div className="min-h-screen flex flex-col selection:bg-primary/20 selection:text-primary transition-colors duration-300 text-on-surface contenedor-contenido">
        <Header />
        <WhatsAppFAB />
        <div className="flex-grow w-full max-w-[100vw] overflow-x-hidden">
          <div className="max-w-[1920px] mx-auto w-full">
            <Suspense fallback={<div className="min-h-[50vh] flex items-center justify-center">Cargando...</div>}>
              <Routes>
                <Route path="/auth" element={<Auth />} />
                <Route path="/set-password" element={<SetPassword />} />
                <Route path="/reset-password" element={<ResetPassword />} />
                <Route element={<AuthGuard />}>
                  <Route path="/" element={<Home />} />
                  <Route path="/nuestra-empresa" element={<NuestraEmpresa />} />
                  <Route path="/intelligence" element={<Intelligence />} />
                  <Route path="/compliance" element={<Compliance />} />
                  <Route path="/cumplimiento" element={<Compliance />} />
                  <Route path="/compliance/diagnostico" element={<DiagnosticoExpress />} />
                  <Route path="/cumplimiento/diagnostico" element={<DiagnosticoExpress />} />
                  <Route path="/compliance/metodologia" element={<Methodology />} />
                  <Route path="/cumplimiento/metodologia" element={<Methodology />} />
                  <Route path="/markets" element={<Markets />} />
                  <Route path="/markets/:slug" element={<ArticleDetail />} />
                  <Route path="/golden-ticket" element={<GoldenTicket />} />
                  <Route path="/events" element={<Events />} />
                  <Route path="/admin/blog" element={<AdminBlog />} />
                  <Route path="/profile" element={<Profile />} />
                  <Route path="/profile/:userId" element={<Profile />} />
                  <Route path="/legal/privacy" element={<LegalPage type="privacy" />} />
                  <Route path="/legal/terms" element={<LegalPage type="terms" />} />
                  <Route path="/legal/confidentiality" element={<LegalPage type="confidentiality" />} />
                  <Route path="/consultation-booking" element={<ConsultationBooking />} />
                  <Route path="/admin/dashboard" element={<AdminDashboard />} />
                </Route>
              </Routes>
            </Suspense>
          </div>
        </div>
        <Footer />
      </div>
    </Router>
  );
}

